import { ReservationStatus } from "@/main/types/reservation.type";

// Single source of truth for how each reservation status is colored across
// the schedule calendar - both Schedule-X's own `calendars` config (which
// colors the month-agenda date dots and any default event chips) and our
// custom event-rendering components read from this same table.
export const RESERVATION_STATUS_COLORS: Record<
  ReservationStatus,
  { main: string; container: string; onContainer: string }
> = {
  [ReservationStatus.Draft]: {
    main: "#757575",
    container: "#e0e0e0",
    onContainer: "#212121",
  },
  [ReservationStatus.Created]: {
    main: "#757575",
    container: "#e0e0e0",
    onContainer: "#212121",
  },
  [ReservationStatus.Confirmed]: {
    main: "#7cb342",
    container: "#dcedc8",
    onContainer: "#33691e",
  },
  [ReservationStatus.Rejected]: {
    main: "#e53935",
    container: "#ffcdd2",
    onContainer: "#b71c1c",
  },
  [ReservationStatus.Canceled]: {
    main: "#e53935",
    container: "#ffcdd2",
    onContainer: "#b71c1c",
  },
  [ReservationStatus.Completed]: {
    main: "#43a047",
    container: "#c8e6c9",
    onContainer: "#1b5e20",
  },
  [ReservationStatus.Archived]: {
    main: "#3949ab",
    container: "#c5cae9",
    onContainer: "#1a237e",
  },
  [ReservationStatus.Missed]: {
    main: "#f4511e",
    container: "#ffccbc",
    onContainer: "#bf360c",
  },
};
